import type { ProvideElementsDirective } from 'src/app/element-handling';

export const enum CustomEvents {
  Unknown = -1,
  TreeMapClick,
  Back,
  ElementsLoaded,
  ElementLoadError,
}

// Must be class with static variables.
// Namespaces, enums, const enums or const objects won't work for @HostListener.
export class CustomDomEvents {
  private constructor() {}

  public static readonly ELEMENT_LOAD_ERROR = 'reporting-widgets-element-load-error';
}

// prettier-ignore
export type CustomEventData<T extends CustomEvents> =
    T extends CustomEvents.TreeMapClick ? string
  : T extends CustomEvents.ElementsLoaded ? { source: ProvideElementsDirective, count: number }
  : T extends CustomEvents.Unknown ? unknown
  : null;
